import { Skeleton } from '@lokalise/louis';
import { styled } from '@lokalise/styled';

import { spacing } from '@app/theme';

export const CreatedByLoadingContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    grid-gap: ${spacing(2)};
    margin: ${spacing(1, 0)};
`;

export const AlignedRightSkeleton = styled(Skeleton)`
    display: flex;
    justify-content: flex-end;
`;
